<template>
  <navigation-layout ref='navigationlayout'>
    <h1 slot="title">{{title}}</h1>
    <h3 slot="abstract">{{abstract}}</h3>
    <main>
      <div class="md-layout" id='integratorlist'>
        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-for="(integrator, index) in integrators" :key="index">
          <md-list>
            <md-list-item>
              <div class="md-list-item-text">
                <span v-text="integrator.name"></span>
                <span v-for="(trustedDomain, indextrusted) in integrator.trustedDomains" :key="indextrusted" v-text="trustedDomain"></span>
              </div>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </main>
  </navigation-layout>
</template>

<script>
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import Field from '@/components/elements/field'
import NotificationService from '@/services/notificationService'
import MultipleFields from '@/components/elements/multiplefields'
import Utils from '@/utils/utils'

export default {
  name: 'list-integrators',
  data: () => ({
    title: 'Integrators',
    abstract: 'List of all integrators',
    integrators: [],
    sending: false
  }),
  components: {
    NavigationLayout,
    Field,
    MultipleFields
  },
  created: async function () {
    this.loading = true
    await NotificationService.manageNotification(this, await RepositoryService.getIntegrators(),
      (data) => {
        this.integrators = data.integrators.sort(Utils.orderArrayObjectByFieldNumberAsc('name'))
      })
    this.loading = false
  }
}

</script>

<style lang="scss" scoped>
  .md-list {
    width: 320px;
    max-width: 100%;
    display: inline-block;
    vertical-align: top;
    border: 1px solid rgba(#000, .12);
  }
</style>
